const TeacherDic = {
    'DayTimeReview' : {
        'fa' : 'بررسی روز و ساعت'
    },
    'allTimeIsLocalize' : {
        'fa' : 'تمامی ساعت ها بر اساس زمان محلی شما تنظیم شده است'
    }
}
export default TeacherDic